import React from 'react';
import {useForm} from 'react-hook-form';

import Pagina, {esMayorOIgualACero} from "../comun/Pagina";
import SelectReactHookForm from "../comun/SelectReactHookForm";
import MensajeValidacion from "../comun/MensajeValidacion";

import '../../css/sismo_sentido.css';

import efectosPersonas from '../../img/efectos_personas.png';
import PaginaAdelanteAtras from './PaginaAdelanteAtras';
import SelectReactHookForm2 from '../comun/SelectReactHookForm2';

export default function Pagina2(props) {
    const pisos = [
        {nombre: "Selecciona", codigo: -1},
        {nombre: "Sótano", codigo: 0},
        {nombre: "1", codigo: 1},
        {nombre: "2", codigo: 2},
        {nombre: "3", codigo: 3},
        {nombre: "4", codigo: 4},
        {nombre: "5", codigo: 5},
        {nombre: "Mayor a 5", codigo: 6}
    ];

    const intensidades = [
        {nombre: "Selecciona", codigo: -1},
        {nombre: "Leve", codigo: 1},
        {nombre: "Moderado", codigo: 2},
        {nombre: "Fuerte", codigo: 3},
        {nombre: "Muy fuerte", codigo: 4}
    ];

    const perdisteEquilibrio = [
        {nombre: "Selecciona", codigo: -1},
        {nombre: "No", codigo:0},
        {nombre: "Sentí mareo", codigo:1},
        {nombre: "Perdí el equilibrio", codigo:2},
        {nombre: "Tuve dificultad para mantenerme de pie", codigo:3}
    ];

    const personasCerca = [
        {nombre: "Selecciona", codigo: -1, key:"a"},
        {nombre: "No sé", codigo: 0.2, key:"bs"},
        {nombre: "Nadie lo sintió", codigo: 0, key:"b"},
        {nombre: "Algunos lo sintieron y otros no", codigo: 0.5, key:"c"},
        {nombre: "La mayoría lo sintió", codigo: 1, key:"d"},
        {nombre: "Todos lo sentimos", codigo: 1, key:"e"},
        {nombre: "Estaba solo/a", codigo: 0, key:"f"}
    ];

    const {register, handleSubmit, getValues, watch, formState:{errors}} = useForm();   

    const wdes = watch("donde_estaba");    
    var donde_estaba = null;
    console.log("wdes 1:"+wdes)
    if (typeof(wdes) == 'undefined') {
        console.log("wdes 2:"+wdes)
        if (props.state.donde_estaba) {
            donde_estaba = props.state.donde_estaba;
        } else {
            donde_estaba = 0;
        }        
    } else {
        donde_estaba = wdes;
    }
    
    const validarPiso = (valor) => {
        if (donde_estaba == 0) {
            return true;
        }
        return parseInt(valor) >= 0;
    };

    const regSelPisos = register("selPisos", { required: donde_estaba == 1, validate: validarPiso });    
    const regSelIntensidades = register("selIntensidades", { required: true, validate: esMayorOIgualACero });
    const regSelEquilibrio = register("selEquilibrio", { required: true, validate: esMayorOIgualACero });
    const regSelPersonasCerca = register("selPersonasCerca", { required: true, validate: esMayorOIgualACero });
    
    return (
        <PaginaAdelanteAtras
        titulo="Efectos en personas"
        imgSrc={efectosPersonas}
        imgAlt="Efectos en personas"
        handleSubmit={handleSubmit}
        avanzarPagina={props.avanzarPagina}
        retrocederPagina={props.retrocederPagina}
        setState={props.setState}
        explicacion={
            <React.Fragment>
                En esta sección hacemos preguntas relacionadas con tu percepción de la intensidad del sismo y las reacciones que tuviste
            </React.Fragment>
        }
        contenidoPrincipal= {
            <React.Fragment>
                <div>
                <div className="TextoMedianoVerde">¿En qué lugar te encontrabas en el momento del sismo?</div>               
                    <div className='ContenedorHCentrado' >                        
                        <input type="radio"                 
                        value="1"  {...register("donde_estaba", {required: true})} defaultChecked={props.state.donde_estaba == 1}/>
                            <label htmlFor="html">Dentro de una edificación</label>
                        <div className='SeparadorHorizontal' />
                        
                        <input type="radio" id="afuera" {...register("donde_estaba", {required: true})} 
                        value="0" defaultChecked={props.state.donde_estaba == 0}/>
                            <label htmlFor="css">En la calle</label>
                    </div>                    
                    <MensajeValidacion nombre="donde_estaba" errors={errors}/>
                </div>
                
                {(donde_estaba== 1) && (
                <React.Fragment>
                    <div>
                        <div className="TextoMedianoVerde">¿En qué piso estabas?</div>                   
                        
                        <SelectReactHookForm
                        id="selPisos"
                        regSel ={regSelPisos}
                        opciones={pisos}
                        errors={errors} 
                        valorDefault={props.state.selPisos}
                        setState ={props.setState} />
                    </div>

                    <div>
                        <div className="TextoMedianoVerde">¿Saliste a la calle?</div>
                        <div className='ContenedorHCentrado'>
                            <input type="radio" id="salioCalleNo" name="salio_calle" value="0" defaultChecked={props.state.salio_calle==0}
                            {...register("salio_calle", {required: donde_estaba == 1})}/>
                                <label htmlFor="salioCalleNo" >No</label>
                            <div className='SeparadorHorizontal' />
                            <input type="radio" id="salioCalleSi" name="salio_calle" value="1" defaultChecked={props.state.salio_calle==1}
                            {...register("salio_calle", {required: donde_estaba == 1})}/>
                            <label htmlFor="salioCalleSi">Sí</label><br/>         
                        </div>
                    </div>
                    <MensajeValidacion nombre="salio_calle" errors={errors}/>
                </React.Fragment>
                )}

                <div>
                    <div className="TextoMedianoVerde">¿Con qué intensidad sentiste el sismo?</div>                    
                    <SelectReactHookForm
                    id="selIntensidades"
                    regSel ={regSelIntensidades}
                    opciones={intensidades}
                    errors={errors}
                    valorDefault={props.state.selIntensidades}    
                    setState ={props.setState} />
                </div>
             
                <div>
                    <div className="TextoMedianoVerde">¿Qué actividad realizabas cuando sentiste el sismo?</div>
                    <div className='ContenedorHCentrado'>
                        <input type="radio" id="act_en_rep" name="actividad" value="0 rep"  
                        {...register("actividad", {required:true})} defaultChecked={props.state.actividad == "0 rep"}/>
                            <label htmlFor="act_en_rep">En reposo</label>
                        <div className='SeparadorHorizontal' />
                        <input type="radio" id="act_en_mov" name="actividad" value="0 mov" 
                        {...register("actividad", {required:true})}  defaultChecked={props.state.actividad == "0 mov"}/>
                            <label htmlFor="act_en_mov">En movimiento</label>
                        <div className='SeparadorHorizontal' />
                        <input type="radio" id="act_durm" name="actividad" value="1" 
                        {...register("actividad", {required:true})} defaultChecked={props.state.actividad == "1"}/>
                        <label htmlFor="act_durm">Durmiendo y me desperté</label><br/>
                    </div>
                    <MensajeValidacion nombre="actividad" errors={errors}/>
                </div>

                <div>
                    <div className="TextoMedianoVerde">¿Perdiste el equilibrio?</div>
                    <SelectReactHookForm
                    id="selEquilibrio"
                    regSel ={regSelEquilibrio}
                    opciones={perdisteEquilibrio}
                    errors={errors} 
                    valorDefault={props.state.selEquilibrio} 
                    setState ={props.setState}/>
                </div>

                <div>
                    <div className="TextoMedianoVerde">¿Las personas que estaban cerca de ti lo sintieron?</div>
                    <SelectReactHookForm
                    id="selPersonasCerca"
                    regSel ={regSelPersonasCerca}
                    opciones={personasCerca}
                    errors={errors} 
                    campoKey="key"
                    valorDefault={props.state.selPersonasCerca}
                    setState ={props.setState}/>
                </div>
            </React.Fragment>
        }
        />
    );
}